import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./module', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

// 需要持久化的存储数据对象
const persistedData = createPersistedState({
  key: 'wly-vuex',
  paths: ['user.userInfo', 'user.sapRoles', 'user.customerInfo', 'user.isCheckRole']
})

export default new Vuex.Store({
  modules,
  getters,
  plugins: [persistedData]
})



// WEBPACK FOOTER //
// ./src/store/index.js